class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

    this.onOutsideClick = this.onOutsideClick.bind(this);
    this.onEscape = this.onEscape.bind(this);

    this.summary.addEventListener('click', (event) => {
      clearTimeout(this.closeTimeout);
      // Confirm a hover-opened menu on the first pointer click. Keyboard
      // activation (detail === 0) and subsequent clicks keep the native toggle.
      if (event.detail > 0 && this.hoverMedia.matches && this.openedByHover && this.mainDetailsToggle.open) {
        event.preventDefault();
        // Dawn's global click listener anticipates a native toggle, which we
        // just canceled; a canceled click will not emit another toggle event.
        this.summary.setAttribute('aria-expanded', true);
      }
      this.openedByHover = false;
    });
    this.addEventListener('focusin', () => clearTimeout(this.closeTimeout));
    this.addEventListener('mouseenter', () => {
      clearTimeout(this.closeTimeout);
      if (!this.hoverMedia.matches || !this.mainDetailsToggle.classList.contains('mega-menu')) return;
      this.closeOtherMenus();
      if (!this.mainDetailsToggle.open) this.openedByHover = true;
      this.mainDetailsToggle.open = true;
    });
    this.addEventListener('mouseleave', () => {
      if (!this.hoverMedia.matches || !this.mainDetailsToggle.classList.contains('mega-menu')) return;
      this.closeTimeout = setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      }, 120);
    });
  }

  connectedCallback() {
    document.addEventListener('click', this.onOutsideClick);
    document.addEventListener('keyup', this.onEscape);
  }

  disconnectedCallback() {
    clearTimeout(this.closeTimeout);
    document.removeEventListener('click', this.onOutsideClick);
    document.removeEventListener('keyup', this.onEscape);
  }

  closeOtherMenus() {
    this.closest('.header__inline-menu').querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
  }

  onOutsideClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  onEscape(event) {
    // Dawn handles Escape inside details; also cover a menu opened by hover
    // while keyboard focus is elsewhere on the page.
    if (event.code.toUpperCase() !== 'ESCAPE' || !this.mainDetailsToggle.open) return;
    this.close();
    this.summary.focus();
  }

  close() {
    clearTimeout(this.closeTimeout);
    this.openedByHover = false;
    if (this.content.contains(document.activeElement)) this.summary.focus();
    super.close();
  }

  onToggle() {
    if (!this.mainDetailsToggle.open) this.openedByHover = false;
    this.summary.setAttribute('aria-expanded', this.mainDetailsToggle.open);
    if (this.mainDetailsToggle.open) this.closeOtherMenus();

    if (!this.header) return;
    this.header.preventHide = !!this.header.querySelector('header-menu > details[open]');

    if (!this.mainDetailsToggle.open) return;

    document.documentElement.style.setProperty(

      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
